import React from 'react';
import './Edge.css';

const Edge = ({ x1, y1, x2, y2, start, end, edgeType, enterNode }) => {
    //const midY = (y1 + y2) / 2;

    //spacing constant used for Klay layout
    const midY = y2 < y1 ? y2 + 105 : y2 - 75;

    //spacing constant used for Sugiyama algorithm
    //const midY = y2 < y1 ? y2 + 105 : y2 - 75;

    const baseCurveRadius = 50;
    const baseCurveRadiusX = Math.min(baseCurveRadius, Math.abs(x2 - x1) / 2);
    const baseCurveRadiusY = Math.min(baseCurveRadius, Math.abs(y2 - y1) / 2);

    // Determine if the curve should be positive or negative based on the end nodes' positions
    const curveRadiusX = x1 < x2 ? baseCurveRadiusX : -baseCurveRadiusX;
    const curveRadiusY = y1 < y2 ? baseCurveRadiusY : -baseCurveRadiusY;

    // offset for arrow showing properly
    //y2 = y2 + 50;

    // Create a path with two slightly curved angles using cubic B�zier curves
    const pathD = `
        M ${x1} ${y1}
        L ${x1} ${midY - curveRadiusY}
        C ${x1} ${midY}, ${x1} ${midY}, ${x1 + curveRadiusX} ${midY}
        L ${x2 - curveRadiusX} ${midY}
        C ${x2} ${midY}, ${x2} ${midY}, ${x2} ${midY + curveRadiusY}
        L ${x2} ${y2}
    `;

    //const pathD = `
    //    M ${x1} ${y1}
    //    L ${x2} ${y2}
    //`;

    let edgeClass = "edge-path";

    if (edgeType === 0) {
        edgeClass += " edge-path-transparent";
    } else if (edgeType === 1) {
        edgeClass += " edge-path-dashed";
    }

    // TODO minor issue where edge with existing edge-path-dashed class will not refresh animation
    // causing overlapping of dashed line
    if (enterNode !== null) {
        if (start === enterNode || end === enterNode) {
            edgeClass = "edge-path-dashed";
        } else {
            edgeClass = "edge-path-transparent";
        }
    }

    return (
        <path
            d={pathD}
            className={edgeClass}
            strokeWidth="6"
            fill="none"
            strokeLinecap="square"
            markerEnd="url(#arrow)"
        />
    );
};

export default Edge;

//<path
//    d={pathD}
//    className="edge-glow" // Add the class name
//    strokeWidth="10" // A larger stroke width to create the glow effect
//    fill="none"
//    strokeLinecap="square"
///>